import {
    CONTENTS_TYPE,
    S3_BUCKET_KEY,
    AWS_INFO
} from '../const/general'
// import fs from 'fs/promises'
import Common from './common';
import { GetObjectCommand, ListObjectsV2Command, S3Client } from "@aws-sdk/client-s3";
import { Credentials } from 'aws-sdk';
// import { createWriteStream } from "fs";
// import { fileURLToPath } from 'url'

const creds = new Credentials(
    AWS_INFO.ACCESS_KEY_ID,
    AWS_INFO.SECRET_ACCESS_KEY
);

const client = new S3Client({
    region: AWS_INFO.REGION, credentials: creds
});

const oneMB = 1024 * 1024 * 8;

export const getObjectRange = ({ bucket, key, start, end }) => {
    const command = new GetObjectCommand({
        Bucket: bucket,
        Key: key,
        //Range:'bytes=1-2'
        Range: `bytes=${start}-${end}`
    });

    return client.send(command);
};

export const getRangeAndLength = (start, end, length) => {
    // const [range, length] = contentRange.split("/");
    // const [start, end] = range.split("-");
    return {
        start: parseInt(start),
        end: parseInt(end),
        length: parseInt(length),
    };
};

export const isComplete = ({ end, length }) => end === length - 1;
// const streamToString = (stream) =>
//     new Promise((resolve, reject) => {
//         const chunks = [];
//         stream.on("data", (chunk) => chunks.push(chunk));
//         stream.on("error", reject);
//         stream.on("end", () => resolve(Buffer.concat(chunks).toString("utf8")));
//     });
export default async function download(
    contents_type, contents_uuid, file_name,
    setSingleDownloadDialogOpen,
    setSnackBarMessage,
    setSnackBarStatus,
    setOpenSnackBar) {

    let key = ''
    // contents_type から S3のキーを取得
    if (contents_type === CONTENTS_TYPE.MOVIE) {
        key += S3_BUCKET_KEY.MOVIE_ORIGINAL
    } else if (contents_type === CONTENTS_TYPE.IMAGE) {
        key += S3_BUCKET_KEY.IMAGE_ORIGINAL
    } else if (contents_type === CONTENTS_TYPE.ZIP) {
        key += S3_BUCKET_KEY.ZIP_ORIGINAL
    }
    // S3のキーにuuid追加
    key += contents_uuid + '.'
    // S3のキーに拡張子追加
    key += file_name.split('.').pop()
    console.log(key)
    // const command = new GetObjectCommand({
    //     Bucket: AWS_INFO.S3_BUCKET_NAME,
    //     Key: key,
    // });
    // const url = await getSignedUrl(client, new GetObjectCommand({
    //     Bucket: process.env.TEST_REGION,
    //     Key: process.env.TEST_KEY,
    //     Range: "0-19"
    // }));
    // const response = await fetch(url, {
    //     method: 'GET',
    //     headers: {
    //         "range": "0-19"
    //     }
    // });

    const bucket = AWS_INFO.S3_BUCKET_NAME
    const response = await client.send(new ListObjectsV2Command({
        Bucket: bucket,
        Prefix: key
    }));
    console.log("ContentSize: ", response.Contents[0].Size)

    //let rangeAndLength = { start: -1, end: -1, length: -1 };
    // カーソル初期値
    let rangeAndLength = { start: -1, end: -1, length: response.Contents[0].Size };
    let str = ''
    let isfinal = false
    let str_bk = ''
    const ext = file_name.split('.').pop()
    const date_time = Common.formatDateTime(new Date(), 'YYYYMMDD_HHmmdd');

    try {
        //  const writeStream = fs.createWriteStream(`edison_drone_archive_${date_time}.${ext}`)
        //   ).on("error", (err) => console.error(err));



        while (!isfinal) {
            const { end, length } = rangeAndLength;
            let nextRange={}
            if (length < oneMB){
                nextRange = { start: end + 1, end: length-1 };
                isfinal= true
            }else{
                nextRange = { start: end + 1, end: end + oneMB };
            }

            console.log(`Downloading bytes ${nextRange.start} to ${nextRange.end}`);

            const response = await client.send(new GetObjectCommand({
                Bucket: bucket,
                Key: key,
                Range: `bytes=${nextRange.start}-${nextRange.end}`
            }));
            console.log("ContentRange: ", response.ContentRange)
            console.log("metadata: ", response.$metadata)
            console.log("AcceptRanges: ", response.AcceptRanges)
            console.log("ContentLength: ", response.ContentLength)
            console.log("Body: ", response.Body)

            const response_bk = await client.send(new GetObjectCommand({
                Bucket: AWS_INFO.S3_BUCKET_NAME,
                Key: key,
            }));
            console.log("Body_bk: ", response_bk.Body)
            str_bk = await response_bk.Body.transformToByteArray();
            str_bk = await response_bk.Body.transformToByteArray();
    
            // const { ContentRange,Body } = await getObjectRange({
            //     bucket,
            //     key,
            //     ...nextRange,
            // });
            // // // // console.log(`Downloading bytes ${Body.getReader()}`);
            // // // // const bodyContents = await streamToString(Body);
            // writeStream.write(await response.Body.transformToByteArray());
            // str += await response.Body.transformToByteArray();
             console.log(response.ContentRange);
            console.log(str);
            console.log(str_bk);
            rangeAndLength = getRangeAndLength(nextRange.start, nextRange.end, rangeAndLength.length - nextRange.end);
        }
        const blob = new Blob([str_bk]);
        const a = document.createElement('a');
        a.download = `edison_drone_archive_${date_time}.${ext}`;
        a.href = URL.createObjectURL(blob);
        a.click();
        URL.revokeObjectURL(a.href);
        setSingleDownloadDialogOpen(false);
        setSnackBarMessage('ファイルをダウンロードしました')
        setSnackBarStatus('success')
        setOpenSnackBar(true)
    } catch (err) {
        console.error(err);
        setSingleDownloadDialogOpen(false);
        setSnackBarMessage('ファイルのダウンロードに失敗しました')
        setSnackBarStatus('error')
        setOpenSnackBar(true)
    }
};